import React, { useEffect, useState } from 'react'

interface ToastProps {
  showToast: boolean
  msg: string
  handleSetShowToast: (show: boolean) => void
}

const Toast: React.FC<ToastProps> = ({ showToast, msg, handleSetShowToast }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (showToast) setShow(showToast)
  }, [showToast])

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false)
        handleSetShowToast(false)
      }, 4000)
    }
  }, [show])

  if (!show) return null

  return (
    <div className="fixed right-0 bottom-10 z-50 m-8 w-5/6 max-w-sm md:w-full">
      <div className="close flex h-24 w-full cursor-pointer items-center justify-between justify-around rounded-3xl bg-primary p-2 text-white shadow-lg">
        <span className="h3 p-2 !font-sans">{msg}</span>
        <svg
          className="fill-current text-white"
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 18 18"
          onClick={() => setShow(false)}
        >
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </div>
    </div>
  )
}

export default Toast
